import React from 'react';
import './LegacyV2SwitchFooter.css';

import { useDesignVersion } from '../../context/useDesignVersion';

const LegacyV2SwitchFooter: React.FC = () => {
  const { setDesignVersion } = useDesignVersion();

  const handleSwitchToModern = () => {
    setDesignVersion('modern');
  };

  return (
    <footer className="legacy-app-footer" aria-label="Переключение интерфейса">
      <button type="button" className="legacy-app-footer__v2-link" onClick={handleSwitchToModern}>
        Новая версия <span aria-hidden="true">↗</span>
      </button>
    </footer>
  );
};

export default LegacyV2SwitchFooter;
